import { render, staticRenderFns } from "./BillingDetailSumStrgPltUsedIndex.vue?vue&type=template&id=27c486c0&scoped=true&"
import script from "./BillingDetailSumStrgPltUsedIndex.vue?vue&type=script&lang=js&"
export * from "./BillingDetailSumStrgPltUsedIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingDetailSumStrgPltUsedIndex.vue?vue&type=style&index=0&id=27c486c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c486c0",
  null
  
)

export default component.exports